import { GlobalStore } from "store/global/GlobalStore";
import { useStoreState } from "pullstate";
import { useState } from "react";
import { ApprovalStore } from "../../../../store/approvals/ApprovalsStore";
import { Caret, ToggleButton } from "./DebugPanelGlobalStoreToggle";
import { isObject } from "lodash-es";

export const DebugPanelApprovalStoreToggle = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const [showApprovalStoreStates, setShowApprovalStoreStates] = useState(false);
  const [expandedKeys, setExpandedKeys] = useState<Array<string>>([]);
  const approvalStore = useStoreState(ApprovalStore);

  const handleCopyToClipboard = (value: unknown) => {
    void navigator.clipboard.writeText(JSON.stringify(value, null, 4));
  };
  const handleToggleExpand = (key: string) => {
    setExpandedKeys(
      (prev: Array<string>): Array<string> =>
        prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]
    );
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignContent: "center",
          font: theme.Desktop.Paragraph.Medium,
          marginBottom: 6,
        }}
      >
        <span>Approval store states:</span>
        <ToggleButton
          toggleButtonText=""
          checked={showApprovalStoreStates}
          handleOnToggle={() => {
            setShowApprovalStoreStates(s => !s);
          }}
        />
      </div>
      {showApprovalStoreStates &&
        Object.entries(approvalStore).map(([key, value]) => {
          const isObjectValueOrObjectArray =
            (typeof value === "object" && value !== null) || Array.isArray(value);
          const isExpanded = expandedKeys.includes(key);

          const isEmpty =
            isObjectValueOrObjectArray &&
            (Array.isArray(value)
              ? value.length === 0
              : isObject(value) && Object.keys(value).length === 0);
          let content;

          if (isObjectValueOrObjectArray && isExpanded) {
            content = (
              <div>
                {Array.isArray(value) ? (
                  value.map((item, index) => (
                    <div key={index}>
                      <span>{JSON.stringify(item, null, 4)}</span>
                      {index < value.length - 1 && <br />}{" "}
                      {/* Add line break except for the last item */}
                    </div>
                  ))
                ) : (
                  <span>{JSON.stringify(value, null, 4)}</span>
                )}
              </div>
            );
          } else if (!isObjectValueOrObjectArray) {
            content = <span>{value}</span>;
          } else {
            content = null; // or an empty string if you prefer
          }

          return (
            <div key={key} style={{ maxWidth: "200px" }}>
              <span
                onClick={() => (isObjectValueOrObjectArray ? handleCopyToClipboard(value) : "")}
              >
                {key}:
                {isObjectValueOrObjectArray && !isEmpty && (
                  <Caret onClick={() => handleToggleExpand(key)} expanded={isExpanded} />
                )}
              </span>
              {content}
            </div>
          );
        })}
    </div>
  );
};
